import type { SegmentedOption } from "../../ui/kit/index.ts";
import type { RunMode } from "../run/intent.ts";

/**
 * The Run setting as Settings offers it (ADR-116 decision 11): Hold, running while Shift is down, then Toggle, a
 * switch a press and release of Shift flips. A choice's value is the text the store keeps for it (`settings.ts`), so
 * the segmented choice, the store and the page's run read one format. The two words are drafts for the author.
 */
export const RUN_MODE_CHOICES: readonly SegmentedOption<RunMode>[] = [
  { value: "hold", label: "Hold" },
  { value: "toggle", label: "Toggle" },
];
